import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { profile } from '../data/profile';
const links = [{
  href: '#expertise',
  label: 'Expertise'
}, {
  href: '#career',
  label: 'Career'
}, {
  href: '#credentials',
  label: 'Credentials'
}, {
  href: '#contact',
  label: 'Contact'
}];
export function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${scrolled ? 'border-navy/10 bg-white/95 backdrop-blur' : 'border-transparent bg-canvas'}`} data-id="element-114" data-mp="zxllqyobacpe">
      <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-6 lg:px-10" data-id="element-115" data-mp="2bbfnsbqanjm4">
        <a href="#top" className="flex items-center gap-3" data-id="element-116" data-mp="29isdzw1u0nqg">
          <span className="flex h-9 w-9 items-center justify-center border border-gold/60 bg-navy font-display text-sm font-bold text-gold" data-id="element-117" data-mp="2ein1rqqb8x7a">
            ES
          </span>
          <span className="hidden flex-col leading-tight sm:flex" data-id="element-118" data-mp="2jfwy7qc4a94m">
            <span className="font-display text-sm font-bold uppercase tracking-[0.2em] text-navy" data-id="element-119" data-mp="2ofrru1na1ctd">
              {profile.name}
            </span>
            <span className="text-[11px] font-medium uppercase tracking-[0.16em] text-navy-steel/70" data-id="element-120" data-mp="1vsf2xktn8sww">
              PMO Chief · Senior Executive Leader, USA
            </span>
          </span>
        </a>

        <nav aria-label="Primary" className="hidden items-center gap-8 md:flex" data-id="element-121" data-mp="25i8fao1m1c27">
          {links.map(link => <a key={link.href} href={link.href} className="text-xs font-semibold uppercase tracking-[0.16em] text-navy-steel transition-colors hover:text-gold-dark" data-id="element-122" data-mp="183cpyq9yfo8q">
              {link.label}
            </a>)}
          <a href={profile.linkedin} target="_blank" rel="noopener noreferrer" className="border border-navy bg-navy px-4 py-2 text-xs font-semibold uppercase tracking-[0.16em] text-white transition-colors hover:bg-navy-steel" data-id="element-123" data-mp="10250yvowr9tb">
            LinkedIn
          </a>
        </nav>

        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-label={open ? 'Close menu' : 'Open menu'} className="inline-flex h-10 w-10 items-center justify-center border border-navy/15 text-navy md:hidden" data-id="element-124" data-mp="m1kk452jzo2g">
          {open ? <XIcon className="h-5 w-5" data-id="element-125" data-mp="r0f8rnn7c6uh" /> : <MenuIcon className="h-5 w-5" data-id="element-126" data-mp="r05is025pzos" />}
        </button>
      </div>

      {open && <nav aria-label="Mobile" className="border-t border-navy/10 bg-white px-6 py-4 md:hidden" data-id="element-127" data-mp="27e5ipb105pc1">
          <ul className="flex flex-col divide-y divide-navy/5" data-id="element-128" data-mp="22iykujuezev1">
            {links.map(link => <li key={link.href} data-id="element-129" data-mp="2ez7xkg8dy27i">
                <a href={link.href} onClick={() => setOpen(false)} className="block py-3 text-xs font-semibold uppercase tracking-[0.16em] text-navy-steel" data-id="element-130" data-mp="2ezhme0hp23bm">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>}
    </header>;
}